import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { TrendingUp, TrendingDown, RefreshCw } from 'lucide-react';
import { BACKEND_URL } from '../config';

const IndicesPage = () => {
  const [indices, setIndices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  const fetchIndices = async (showLoading = false) => {
    try {
      if (showLoading) setLoading(true);
      const response = await fetch(`${BACKEND_URL}/api/indices/prices`);
      const data = await response.json();
      if (Array.isArray(data)) {
        setIndices(data);
        setLastUpdate(new Date());
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching indices:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIndices(true);
    const interval = setInterval(() => fetchIndices(false), 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="relative bg-gradient-to-br from-[#0d6571] to-[#0d6571]/80 py-20">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-5xl font-bold text-white mb-4">
            Stock Market Indices
          </h1>
          <p className="text-xl text-white/90">
            Major global stock market indices and their performance
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
          {indices.map((index, idx) => (
            <div key={idx} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">{index.name}</h3>
                  <p className="text-sm text-gray-500">{index.symbol} • {index.country}</p>
                </div>
                {index.change >= 0 ? (
                  <TrendingUp className="w-8 h-8 text-green-600" />
                ) : (
                  <TrendingDown className="w-8 h-8 text-red-600" />
                )}
              </div>

              <div className="mb-4">
                <div className="text-4xl font-bold text-gray-900">
                  {index.price.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </div>
                <div className={`text-lg font-semibold mt-2 ${
                  index.change >= 0 ? 'text-green-600' : 'text-red-600'
                }`}>
                  {index.change >= 0 ? '+' : ''}{index.change.toFixed(2)}%
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-white rounded-xl shadow-lg p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Market Information</h2>
          <p className="text-gray-600">
            Index values shown are indicative market rates. Real-time data integration available upon request.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default IndicesPage;